import { useEffect, useState, memo } from 'react';
import { useParams } from 'react-router-dom';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavItem from './NavItem';
import NavGroup from './NavGroup';
import menuItem from 'menu-items'; // menu-items/index.js
import { useDispatch, useSelector } from 'store';
import { usePermissions } from 'contexts/PermissionContext';

// assets
import { IconLayoutBoard } from '@tabler/icons';

import { getProjects } from 'store/slices/project';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { workspaceId } = useParams();
    const [navItems, setNavItems] = useState([]);
    const { selectedWorkspace } = useSelector((state) => state.workspace);
    const { hasPermission } = usePermissions();

    useEffect(() => {
        setNavItems(menuItem.items.map((item) => {
            item.children = item.children?.map((c) => {
                return {
                    ...c,
                    url: `/w/${workspaceId}${c.baseurl}`,
                    children: c.children?.map((cc) => {
                        const hidden = cc.id !== 'account-setting' 
                            && (((!selectedWorkspace?.isOwner || !hasPermission('workspace_management')) && (cc.id === 'workspace-setting' || cc.id === 'billing')) 
                            || ((!selectedWorkspace?.isAdmin || selectedWorkspace.plan === 'Trial' || !hasPermission('workspace_management')) && cc.id === 'member'))
                        return {
                            ...cc,
                            hidden: hidden,
                            url: `/w/${workspaceId}${cc.baseurl}`
                        }
                    })
                }
            })
    
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        }))
    }, [workspaceId, selectedWorkspace]);

    return <>{navItems}</>;
};

export default memo(MenuList);
